export enum ELanguages {
  fr,
  en,
  nl,
}
